import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ForgotPasswordType = {
    email: string;
}

export type InitialForgotPasswordState = {
    answers: ForgotPasswordType
}

export const initialForgotPasswordState: InitialForgotPasswordState = {
    answers: {
        email: '',
    },
};

const reducers = {
    setAnswers: (
        state,
        action: PayloadAction<{ [key: string]: string }>,
    ) => ({
        ...state,
        answers: {
            ...state.answers,
            ...action.payload,
        },
    }),
    setDefaultInitialForgotPasswordState: () => ({
        ...initialForgotPasswordState,
    }),
};

const forgotPasswordSlice = createSlice({
    name: 'forgotPasswordSlice',
    initialState: initialForgotPasswordState,
    reducers,
});

export default forgotPasswordSlice;
